// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductDescriptionFromStaticContent_title__GEY4V"};